export default "__VITE_ASSET__NdDExdRq__"